import "./ChangePw.scss";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import axios from "axios";
import loginView from "@/views/Login/Login.js";
export default {
  name: "changePw",
  data: () => ({
    password: "",
    password2: "",
    username: "",
    showForm: true,
    redirect: false
  }),
  props: {
    secret: { default: "" }
  },
  created() {
    if (window.localStorage.session) {
      if (confirm("Sie sind bereits eingeloggt. Möchten Sie sich ausloggen?")) {
        localStorage.clear();
        window.location.reload();
      }
    }
  },
  async mounted() {
    const res = await axios.get(
      env.auth_api_client_url + "users/changePwInfo?secret=" + this.secret
    );
    this.username = res?.data?.username;
  },
  methods: {
    async changePw() {
      if (this.password !== this.password2) {
        await this.$store.dispatch("createError", {
          text: "Passwörter stimmen nicht überein!"
        });
        return;
      }
      if (this.password.length < 6) {
        await this.$store.dispatch("createError", {
          text: "Bitte mindestens 6 Zeichen für das neue Passwort verwenden!"
        });
        return;
      }
      const result = await axios.post(
        env.auth_api_client_url + "users/changePw",
        {
          secret: this.secret,
          password: this.password
        }
      );
      if (result?.data?.message === "pwUpdated") {
        this.showForm = false;
        this.redirect = true;
        setTimeout(async () => {
          try {
            loginView.methods.login(this.username, this.password, this);
          } catch (err) {
            await this.$store.dispatch("createError", {
              text: "Fehler beim einloggen!"
            });
            this.showForm = true;
          }
        }, 1000);
      } else {
        console.error("password not updated", result?.data);
      }
    }
  }
};
